// extracted by mini-css-extract-plugin
export default {"appVersionInfo":"appVersionInfo--eHKnb"};